module.exports = __webpack_public_path__ + "static/media/fMINUTA COMPRAVENTA FINAL.be846253.pdf";